import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { getTestimonials } from "@/lib/servicesApi";
import { S } from "./summaryCopy";

// Real quotes from real past customers, entered by the owner in the admin
// panel (see pages/admin/Testimonials.jsx) — never generated. Renders
// nothing while loading, on a fetch error, or when there simply aren't any
// yet, rather than showing an empty section or a loading flicker.
export default function Testimonials({ lang }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let alive = true;
    getTestimonials().then((r) => alive && setRows(Array.isArray(r) ? r : [])).catch(() => alive && setRows([]));
    return () => { alive = false; };
  }, []);

  if (!rows || rows.length === 0) return null;
  const C = (S[lang] || S.de).testimonials;

  return (
    <section className="mt-6" data-testid="testimonials">
      <h2 className="mb-3 font-heading text-lg font-semibold sm:text-xl">{C.title}</h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {rows.map((t, i) => (
          <div key={`${t.name}-${i}`} className="flex flex-col rounded-2xl border bg-card p-4 shadow-sm">
            <Quote className="mb-2 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
            <p className="text-base italic text-foreground">„{t.quote}"</p>
            <p className="mt-3 text-sm font-medium text-muted-foreground">
              {t.name}{t.company ? <span className="font-normal">, {t.company}</span> : null}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
